export const LOCAL_STORAGE_KEYS = {
  MEDIA_VOLUME: 'RecordingReviewComponent:MediaVolume'
};